<div id="call-queue-container">

  <div *ngIf="queue.length > 0" class="queue-toggle" [matMenuTriggerFor]="callQueue">
    <div class="coming-up">
      <div class="coming-up-label">Coming Up:</div>
      <div class="coming-up-business-name">{{ queue[0].businessName }}</div>
    </div>
    <button class="queue-btn mat-elevation-z4">
      <span class="fa fa-caret-down"></span>
    </button>
  </div>

  <mat-menu #callQueue="matMenu" class="queue-menu">
    <div>
      <div class="queue-header">Up Next</div>
      <div cdkDropList class="queue-list" (cdkDropListDropped)="reorderDrop($event)">
        <div class="queue-box" *ngFor="let queuedCall of queue; let first = first" cdkDrag [ngClass]="{ true: 'current', false: '' }[first]">
          <div class="list-item">
            <a [routerLink]="['/borrower/' + queuedCall.borrowerId]" class="business-name col-name">{{ queuedCall.businessName }}</a>
            <span class="col-status">{{ readableStatus(queuedCall.status) }}</span>
            <span (click)="handleRemoveBorrower(queuedCall.borrowerId); $event.stopPropagation()" class="col-remove fa fa-times"></span>
          </div>
        </div>
        <div class="clear-queue-btn" (click)="handleClearQueue()">
          <span class="clear-queue">Clear Queue</span>
        </div>
      </div>
    </div>
  </mat-menu>
</div>
